export const CryptoCurrencies = Object.freeze({
    BITCOIN: "BTC",
    ETHEREUM: "ETH",
    USDT: "USDT",
    USDC: "USDC",
    TRX: "TRX",
    DOGECOIN: "DOGE",
    LITECOIN: "LTC",
    XRP: "XRP"
});